import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  Legend
} from 'recharts';

const NotesCharts = ({ stats }) => {
  if (!stats) return null;

  const COLORS = ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6', '#F97316'];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
      {/* Distribution des notes */}
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Distribution des notes</h3>
        <ResponsiveContainer width="100%" height={400}>
          <RechartsPieChart>
            <Pie
              data={stats.distributionData}
              cx="50%"
              cy="40%"
              outerRadius={90}
              fill="#8884d8"
              dataKey="value"
              label={({name, percentage}) => `${percentage}%`}
            >
              {stats.distributionData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value, name) => [`${value} étudiants`, name]} />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
              formatter={(value, entry) => (
                <span style={{ color: entry.color, fontSize: '14px', fontWeight: '500' }}>
                  {value}
                </span>
              )}
            />
          </RechartsPieChart>
        </ResponsiveContainer>
      </div>

      {/* Histogramme des notes */}
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Histogramme des notes</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={stats.histogrammeData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="tranche" />
            <YAxis />
            <Tooltip formatter={(value) => [`${value} étudiants`, 'Nombre']} />
            <Bar dataKey="count" fill="#3B82F6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default NotesCharts; 